import { myAxios } from "../../../utils/common";

export interface CoverageRow {
  module_id: number;
  code: string;
  title: string;
  total: number;
  test_count: number;
  with_tests: number;
  d1: number;
  d2: number;
  d3: number;
}

export interface CohortStudentRow {
  user_id: number;
  first_name: string;
  last_name: string;
  attempts: number;
  avg_score: number | null;
  last_at: string | null;
}

export interface WeakTopicRow {
  code: string;
  title: string;
  asked: number;
  correct: number;
}

export interface CohortReport {
  students: CohortStudentRow[];
  weakTopics: WeakTopicRow[];
}

export interface CohortLite {
  id: number;
  name: string;
}

export const quizReportApi = {
  coverage: () =>
    myAxios.get<CoverageRow[]>("/module-practice/admin/coverage").then((r) => r.data),

  cohort: (cohortId: number, moduleId?: number) =>
    myAxios
      .get<CohortReport>(`/module-practice/admin/cohort/${cohortId}`, {
        params: moduleId ? { moduleId } : undefined,
      })
      .then((r) => r.data),

  cohorts: () => myAxios.get<CohortLite[]>("/cohorts").then((r) => r.data),
};
